import { useMemo } from 'react';

import { eocUserResource } from '@atlassian/eoc-resources';
import { useResource } from '@atlassian/eoc-rrr-helpers';
import { type ResponderType } from '@atlassian/eoc-schedule-common';

/**
 * @warning Responder here has only atlassianIdentifier, not OG ID
 * @returns {object} JSM user in same format as ResponderItem
 */
const useCurrentUser = () => {
	const jsmUser = useResource(eocUserResource);

	const current = useMemo(
		() => ({
			isLoading: jsmUser.loading,
			isError: jsmUser.error,
			user:
				jsmUser.loading || jsmUser.error
					? undefined
					: {
							atlassianIdentifier: jsmUser.data!.accountId,
							label: jsmUser.data!.displayName,
							type: 'user' as ResponderType<false>,
							// NOTE: it is not safe to use 'value' (traditionally corresponds to ops id)
							value: jsmUser.data!.accountId,
						},
		}),
		[jsmUser],
	);

	return current;
};

export { useCurrentUser };
